import { TIMEScreeningState as State } from '../api/types/timeScreeningStore';

export const creators = {
  /*
   * Care Gap Actions
   */
  setCareGapOptions(options: Partial<State['careGap']['options']>) {
    return { type: 'SET_CARE_GAP_OPTIONS', options };
  },
  setCareGapFilters(filters: Partial<State['careGap']['filters']>) {
    return { type: 'SET_CARE_GAP_FILTERS', filters };
  },
  clearCareGapFilters() {
    return { type: 'CLEAR_CARE_GAP_FILTERS' };
  },
  getCarePathwayFilterOptions(carePathwayId: string) {
    return { type: 'GET_CARE_PATHWAY_FILTER_OPTIONS', carePathwayId };
  },
  getCarePathways() {
    return { type: 'GET_CARE_PATHWAYS' };
  },
  getCarePathwayQueueCounts() {
    return { type: 'GET_CARE_PATHWAY_QUEUE_COUNTS' };
  },
  /*
   * Trials Actions
   */
  setTrialOptions(options: Partial<State['trials']['options']>) {
    return { type: 'SET_TRIAL_OPTIONS', options };
  },
  setTrialFilters(filters: Partial<State['trials']['filters']>) {
    return { type: 'SET_TRIAL_FILTERS', filters };
  },
  setTrialSavedFilters(savedFilters: Partial<State['trials']['savedFilters']>) {
    return { type: 'SET_TRIAL_SAVED_FILTERS', savedFilters };
  },
  clearTrialFilters() {
    return { type: 'CLEAR_TRIAL_FILTERS' };
  },
  getTrialFilterOptions(trialId: string) {
    return { type: 'GET_TRIAL_FILTER_OPTIONS', trialId };
  },
  getScreeningTrials() {
    return { type: 'GET_SCREENING_TRIALS' };
  },
  getTimeInstitutions() {
    return { type: 'GET_TIME_INSTITUTIONS' };
  },
};
